<template>
	<el-dialog :visible=" show " title="小程序跳转" width="500px" append-to-body :close-on-click-modal="false" @close="closeDialog">
		<el-form label-width="100px" size="medium">
			<el-form-item label="APPID">
				<el-input value="wx1650cfc85c6fffcb"></el-input>
			</el-form-item>
			<el-form-item label="链接">
				<el-input :value="`pages/preview/preview?id=${row.id}&subjectId=${subjectId}`"></el-input>
			</el-form-item>
			<el-form-item label="首场景封面">
				<div class="box" @click="downloadImage">
					<img class="thumb" :src="row.thumb">
					<div class="mask"><i class="icon el-icon-download"></i></div>
				</div>
				<div class="v-form-tips">点击下载图片</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import axios from 'axios';

	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				subjectId:this.$store.state.user.userInfo.subjectId
      }
		},


		methods: {

			closeDialog() {
				this.$emit('update:show', false);
			},

			async downloadImage(){
				let info = await axios.get(this.row.thumb+'?imageInfo')
				let url= this.row.thumb;
				let x = new XMLHttpRequest()
				x.open('GET', url, true)
				x.responseType = 'blob'
				x.onload =  () =>{
					let url = window.URL.createObjectURL(x.response)
					let a = document.createElement('a')
					a.href = url
					a.download = this.row.name+'.'+info.data.format;
					a.click()
				}
				x.send()
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 300px;
		position: relative;

	}
	.thumb {
		display: block;
		width: 300px;
		height: 150px;
	}
	.mask{
		position: absolute;
		left:0;
		top:0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.5);
		cursor: pointer;
		display: none;
	}

	.box:hover .mask{
		display: block;
	}

	.mask .icon{
		cursor: pointer;
		display: block;
		position: absolute;
		left:50%;
		top:50%;
		transform: translate(-50%,-50%);
		color: #fff;
		font-size: 28px;
	}
</style>

